import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {getUrlParameters} from '../../common/util/urlParameters';

export const fetchLostSalesReportDetail = (filters) => {
  const allFilters = getUrlParameters(filters);

  return apiActionCreator({
    'endpoint': `/orders/dealers/lost_sales${allFilters}`,
    'authenticated': true,
    'types': [
      ActionTypes.GET_LOST_SALES_REPORT,
      ActionTypes.GET_LOST_SALES_REPORT_SUCCESS,
      [
        ActionTypes.GET_LOST_SALES_REPORT_ERROR,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const changeLostSalesReportDetailListPage = (value) => ({
  'type': ActionTypes.CHANGE_LOST_SALES_REPORT_DETAIL_LIST_PAGE,
  'payload': value,
});

export const changeLostSalesReportDetailListPageSize = (value) => ({
  'type': ActionTypes.CHANGE_LOST_SALES_REPORT_DETAIL_LIST_PAGE_SIZE,
  'payload': value,
});

export const fetchDownloadLostSalesReportDetail = (filters = {}) =>
  apiActionCreator({
    'endpoint': '/orders/dealers/lost_sales',
    'authenticated': true,
    'types': [
      ActionTypes.DOWNLOAD_LOST_SALES_REPORT_DETAIL,
      ActionTypes.DOWNLOAD_LOST_SALES_REPORT_DETAIL_SUCCESS,
      [
        ActionTypes.DOWNLOAD_LOST_SALES_REPORT_DETAIL_ERROR,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'POST',
    'contentType': 'application/json',
    'data': filters,
  });

export const getPartLostSalesDetail = ({partCode, description}, filters) =>
  apiActionCreator({
    'endpoint': `/orders/dealers/lost_sales/${partCode}${getUrlParameters(
      filters
    )}`,
    'authenticated': true,
    'types': [
      ActionTypes.GET_PART_LOST_SALES_DETAIL_REQUEST,
      {
        'type': ActionTypes.GET_PART_LOST_SALES_DETAIL_SUCCESS,
        'payload': {partCode, description},
      },
      [
        ActionTypes.GET_PART_LOST_SALES_DETAIL_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const getPartLostSalesReport = (partCode, filters) =>
  apiActionCreator({
    'endpoint': `/orders/dealers/lost_sales/${partCode}`,
    'authenticated': true,
    'types': [
      ActionTypes.GENERATE_PART_LOST_SALES_REPORT_REQUEST,
      ActionTypes.GENERATE_PART_LOST_SALES_REPORT_SUCCESS,
      [
        ActionTypes.GENERATE_PART_LOST_SALES_REPORT_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'POST',
    'contentType': 'application/json',
    'data': filters,
  });

export const clearLostSalesReportDetail = () => ({
  'type': ActionTypes.CLEAR_LOST_SALES_REPORT_DETAIL,
});

export const clearLostSalesSelectedPart = () => ({
  'type': ActionTypes.CLEAR_LOST_SALES_SELECTED_PART,
});

export const updateLostSalesReportFilters = (filters) => ({
  'type': ActionTypes.UPDATE_LOST_SALES_REPORT_FILTERS,
  'payload': filters,
});
